export const locales = {
	title: 'Vos structures d’activité',
	labelRPPS: 'N° RPPS :',
	labelAdeli: '- N° ADELI :',
	infoMessage: 'Si cette liste n’est pas à jour, veuillez contacter votre caisse ou l’assistance technique amelipro au 3608.',
	switchLabel: 'J’en fais ma structure par défaut',
	switchDescription: 'En définissant une structure par défaut, cette fenêtre de sélection ne s’affichera plus lors de vos prochaines connexions.',
	cancelLabel: 'Retour',
	confirmLabel: 'Valider'
};
